<template>
    <div>
        <LoadingOverlay :loading="loading" />
        <div class="weeklyRankRewards-tableSec">
            <div class="weeklyRankRewards-HD">Weekly Call Rewards</div>
            <div class="weeklyRankRewards-tableWrap">
                <table>
                    <tbody>
                        <tr v-for="reward in WeeklyRankRewardsRoomData" :key="reward.id">
                            <td>Top {{ reward.rank }}</td>
                            <td><span><img :src='beansIcon' class="beansIcon" alt="" /></span> {{ reward.reward_coin }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="rankingRewards-ruleCont">
            <ul>
                <li>Call rank is based on the minutes of the host consumed in the calls.</li>
                <li>A Streamer has to attend minimum of 50 random calls to get the reward.</li>
                <li>The ranking updating is subjected to 00:00 (GMT +5:30).</li>
            </ul>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import beansIcon from '../../assets/images/beansIcon.png'
import LoadingOverlay from '../LoadingOverlay.vue'
export default {
    name: 'weeklyRankRewardsCall',
    components: {
        LoadingOverlay
    },
    data() {
        return {
            WeeklyRankRewardsRoomData: [],
            beansIcon: beansIcon,
            loading: false
        }
    },
    mounted() {
        this.fetchWeeklyRankRewardsRoomData();
    },
    methods: {
        fetchWeeklyRankRewardsRoomData() {
            this.loading= true;
            const tokenParam = this.$route.params.token;
            const token = tokenParam.split('=')[0];
            const apiUrl = `api/top-call-weekly`;
            axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            })
                .then(response => {
                    this.WeeklyRankRewardsRoomData = response.data.result.weeklyrewards;
                })

                .catch(error => {
                    console.error("Error Featching Weekly Data", error)
                })
                .finally(() => {
                    this.loading = false;
                })
        },
    },
}
</script>